import styled, { css } from "styled-components";

import { color, mixin, zIndexValues } from "../../../utils/styles/styles";
import Icon from "../../atoms/Icon";

export const ScrollOverlay = styled.div`
  z-index: ${zIndexValues.modal};
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  ${mixin.scrollableY}
`;

export const ClickableOverlay = styled.div`
  min-height: 100%;
  background: rgba(13, 13, 13, 0.5);
  backdrop-filter: blur(10px);
 
  ${(props) => clickOverlayStyles[props.variant]}
`;

const clickOverlayStyles = {
  center: css`
    display: flex;
    justify-content: center;
    align-items: center;
    
  `,
  topCenter: css`
    display: flex;
    justify-content: center;
  `,
  aside: "",
};

export const StyledModal = styled.div`
  display: inline-block;
  position: relative;
  background: #fff;
    
  ${(props) => modalStyles[props.variant]}
  @media (max-width: 600px) {
    position:absolute;
  overflow:hidden;
  padding:0;
   bottom:0;
   width:100%;
  }
`;

const modalStyles = {
  center: css`
    vertical-align: middle;
    border-radius: 10px;
    ${mixin.boxShadowMedium}
    @media (max-width: 600px) {
      border-top-left-radius:10px;
      border-top-right-radius:10px;
      border-bottom-left-radius:0px;
      border-bottom-right-radius:0px;
     }
  `,
  topCenter: css`
    vertical-align: middle;
    border-radius: 10px;
    ${mixin.boxShadowMedium}
  `,
  aside: css`
    min-height: 100vh;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  `,
};

export const CloseIcon = styled(Icon)`
  position: absolute;
  font-size: 25px;
  color: ${color.textMedium};
  transition: all 0.1s;
  ${mixin.clickable}
  ${(props) => closeIconStyles[props.variant]}
`;

const closeIconStyles = {
  center: css`
    top: 10px;
    right: 12px;
    padding: 3px 5px 0px 5px;
    border-radius: 4px;
    &:hover {
      background: ${color.backgroundLight};
    }
  `,
  aside: css`
    top: 10px;
    right: -30px;
    width: 50px;
    height: 50px;
    padding-top: 10px;
    border-radius: 3px;
    text-align: center;
    background: #fff;
    border: 1px solid ${color.borderLightest};
    ${mixin.boxShadowMedium};
    &:hover {
      color: ${color.primary};
    }
  `,
};
